import { Button, Col, Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect, useState } from 'react'
import { updateSettingLeaveTypeDateAPI } from '../../../services/setting/leave'
import SwalCustomSuccess from '../../../alert/swal-success'
import Error_false from '../../../components/error/error-false'
import ModalCustom from '../../../components/modal-custom'
import TextError from '../../../components/custom/TextError'

const schema = yup
  .object({
    later: yup.number().required('Required field'),
    advance: yup.number().required('Required field')
  })
  .required()
export default function ModalUpdate({
  show,
  onCancel,
  fnGetDataTable,
  isEdit,
  data
}) {
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({ resolver: yupResolver(schema) })
  const [isSubmit, setIsSubmit] = useState(false)

  const onSubmit = async (d) => {
    const body = {
      later: d.later,
      advance: d.advance
    }
    sendAPI(
      updateSettingLeaveTypeDateAPI({
        ...body,
        leaveTypeId: data.leaveTypeId
      })
    )
  }

  useEffect(() => {
    if (data) {
      setValue('later', data.later)
      setValue('advance', data.advance)
    }
  }, [data, setValue])

  const sendAPI = async (api) => {
    setIsSubmit(true)
    const resp = await api
    setIsSubmit(false)
    if (!resp) return
    if (resp.status) {
      SwalCustomSuccess().then(() => {
        onCancel()
        fnGetDataTable()
      })
    } else {
      Error_false(resp)
    }
  }

  return (
    <ModalCustom
      open={show}
      onCancel={onCancel}
      titleHeader={<span className=""></span>}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="p-3">
        <div className="text-center">
          <h4>Update Leave Type </h4>
          <p className="text-muted">
            Permissions you may use and assign to your users.
          </p>
        </div>
        <Form className="row g-3" onSubmit={handleSubmit(onSubmit)}>
          <Col xl={6}>
            <label className="fw-light small">later</label>

            <Controller
              name={'later'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  type="number"
                  placeholder="Select Profile"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.later && <TextError>{errors.later?.message}</TextError>}
          </Col>

          <Col xl={6}>
            <label className="fw-light small">Advance</label>
            <Controller
              name={'advance'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  type="number"
                  placeholder="Select Profile"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.advance && <TextError>{errors.advance?.message}</TextError>}
          </Col>

          <Col xl={12} className="mt-5 text-center">
            <Button className="me-2 px-4" variant="light" onClick={onCancel}>
              Close
            </Button>

            <Button className="px-4" disabled={isSubmit} type="submit">
              {!isEdit ? (
                <>Create Permission{isSubmit && '...'}</>
              ) : (
                <>Submit{isSubmit && '...'}</>
              )}
            </Button>
          </Col>
        </Form>
      </div>

      {isSubmit && <div className="preloader-isload"></div>}
    </ModalCustom>
  )
}
